









import Vue from 'vue';
import InventoryForm from '@/components/publisher/InventoryForm.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'UpdateInventory',
  components: { InventoryForm },
  props: {
    id: {
      required: true,
    },
  },
  async mounted() {
    this.loadData = true;
    await Promise.all([
      this.$store.commit('changeTitle', this.$t('pages.inventory.title')),
      this.$store.dispatch('publisher/addInventory'),
      this.$store.dispatch('langs'),
      this.$store.dispatch('categories'),
      this.$store.dispatch('publisher/inventory', {
        id: this.id,
        expand: 'languages,categories,placements',
      }),
    ]);
    this.loadData = false;
  },
  destroyed() {
    this.$store.dispatch('publisher/clearAllState');
  },
  computed: {
    ...mapGetters({
      langs: 'langList',
      category: 'categoryList',
    }),
  },
  methods: {
    updateInventory() {
      this.$store.dispatch('publisher/submitForm', {
        APIName: 'updateInventory',
        inventoryId: this.id,
      });
    },
  },
  data() {
    return {
      errors: [],
      loadData: false,
    };
  },
});
